import React from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { FiX } from "react-icons/fi";

import { useInventoryStore } from "../../../store/useInventoryStore";
import Button from "../../Button";

const ORDERING_OPTIONS = [
  { value: "newest", label: "جدیدترین" },
  { value: "oldest", label: "قدیمی‌ترین" },
  { value: "newest_review", label: "جدیدترین بازبینی" },
  { value: "oldest_review", label: "قدیمی‌ترین بازبینی" },
];

const ACTIVE_OPTIONS = [
  { value: "", label: "همه کالاها" },
  { value: "true", label: "کالاهای فعال" },
  { value: "false", label: "کالاهای غیرفعال" },
];

const InventoryToolbar = ({
  selectedWarehouse,
  onSubmit,
  onSearch,
  onClear,
  loading,
}) => {
  const search = useInventoryStore((state) => state.search);
  const isActive = useInventoryStore((state) => state.isActive);
  const dateFrom = useInventoryStore((state) => state.dateFrom);
  const dateTo = useInventoryStore((state) => state.dateTo);
  const ordering = useInventoryStore((state) => state.ordering);

  const setSearch = useInventoryStore((state) => state.setSearch);
  const setIsActive = useInventoryStore((state) => state.setIsActive);
  const setDateFrom = useInventoryStore((state) => state.setDateFrom);
  const setDateTo = useInventoryStore((state) => state.setDateTo);
  const setOrdering = useInventoryStore((state) => state.setOrdering);
  const openExcelModal = useInventoryStore((state) => state.openExcelModal);
  const totalCount = useInventoryStore((state) => state.totalCount);

  const hasFilters = !!(search || isActive || dateFrom || dateTo || ordering !== "newest");
  const toGregorianISO = (date) => {
    if (!date) return '';
    return date.toDate().toISOString();
  };


  return (
    <div className="mb-4 space-y-4">
      <div>
        <h2 className="text-lg font-semibold">
          {selectedWarehouse
            ? `موجودی انبار: ${selectedWarehouse.title}`
            : "موجودی انبار"}
        </h2>
        <p className="text-sm text-gray-500">
          تعداد کالا : {totalCount}
        </p>
      </div>

      <form onSubmit={onSearch} className="space-y-3">
        <div
          className="
            grid grid-cols-1 gap-3
            sm:grid-cols-2
            xl:grid-cols-[2fr_1fr_1fr_1fr_1fr_auto]
            items-center
          "
        >
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="جستجو بر اساس نام، کد، برند، دسته..."
            className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
          />

          <select
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
            className="rounded-lg border border-gray-300 p-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]"
          >
            {ACTIVE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          <DatePicker
            value={dateFrom}
            onChange={setDateFrom}
            calendar={persian}
            locale={persian_fa}
            placeholder="از تاریخ"
            inputClass="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
          />

          <DatePicker
            value={dateTo}
            onChange={setDateTo}
            calendar={persian}
            locale={persian_fa}
            placeholder="تا تاریخ"
            inputClass="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
          />

          <select
            value={ordering}
            onChange={(e) => setOrdering(e.target.value)}
            className="rounded-lg border border-gray-300 p-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]"
          >
            {ORDERING_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                مرتب‌سازی: {option.label}
              </option>
            ))}
          </select>

          <div className="flex items-center gap-2">
            <Button type="submit" className="w-full sm:w-auto">
              جستجو
            </Button>

            {hasFilters && (
              <button
                type="button"
                onClick={onClear}
                title="پاک کردن فیلترها"
                className="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-300 text-gray-500 transition-all hover:border-red-400 hover:bg-red-50 hover:text-red-600"
              >
                <FiX size={18} />
              </button>
            )}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <Button
            type="button"
            variant="secondary"
            onClick={onSubmit}
            disabled={!selectedWarehouse || loading}
          >
            خروجی اکسل
          </Button>

          <Button
            type="button"
            variant="secondary"
            onClick={openExcelModal}
            disabled={!selectedWarehouse || loading}
          >
            بارگذاری اکسل
          </Button>
        </div>
      </form>
    </div>
  );
};

export default InventoryToolbar;
